import { connect } from 'react-redux'

import { changeTeam } from 'app/session/session_actions'
import GetStarted from 'app/sm/ppp/property_components/get-started/get_started'
import {
  cancelModal,
  fetchProfile,
  fetchProperty,
  ping,
  shouldUpdateAd,
  steps,
  update,
  updateField,
} from 'app/sm/profile/profile_actions'

const mapStateToProps = ({ Profile, Shared, session }) => ({
  error: Profile.error,
  profile: Profile.profile,
  spinner: Profile.spinner,
  steps,
  modal: Profile.modal,
  property: Profile.property,
  backUrl: Shared.backUrl,
  teams: session.teams,
})

const mapDispatchToProps = (dispatch) => ({
  ping: () => dispatch(ping()),
  update: (step, data) => dispatch(update(step, data)),
  fetchProfile: () => dispatch(fetchProfile()),
  updateField: (key, val) => dispatch(updateField(key, val)),
  fetchProperty: (slug) => dispatch(fetchProperty(slug)),
  shouldUpdateAd: (propertyId, should) =>
    dispatch(shouldUpdateAd(propertyId, should)),
  cancelModal: () => dispatch(cancelModal()),
  changeTeam: (currentTeam) => dispatch(changeTeam(currentTeam)),
})

export default connect(mapStateToProps, mapDispatchToProps)(GetStarted)
